import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAccounts } from "../lib/account";
import { moneyFor } from "../lib/currency";
import { TrendUp, TrendDown, Minus } from "@phosphor-icons/react";

const CARDS = [
  { key: "daily",   label: "Daily",   sub: "Today vs Yesterday" },
  { key: "weekly",  label: "Weekly",  sub: "This week vs Last week" },
  { key: "monthly", label: "Monthly", sub: "This month vs Last month" },
  { key: "yearly",  label: "Yearly",  sub: "YTD vs Prior year" },
];

export default function PnLComparison({ direction }) {
  const { activeId, activeAccount } = useAccounts();
  const fmt = (v) => moneyFor(activeAccount, v, { sign: true, short: true });
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!activeId) return;
    const p = new URLSearchParams({ account_id: activeId });
    if (direction && direction !== "all") p.set("direction", direction);
    api.get(`/analytics/pnl-comparison?${p.toString()}`).then(({ data }) => setData(data)).catch(() => setData(null));
  }, [activeId, direction]);

  return (
    <div className="rounded-2xl border border-border bg-card p-6" data-testid="pnl-comparison-card">
      <p className="text-[11px] tracking-[0.25em] uppercase text-muted-foreground">Comparisons</p>
      <h3 className="font-display text-lg font-semibold mt-1 mb-4">Period vs previous</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {CARDS.map(c => {
          const d = data?.[c.key];
          const cur = d?.current ?? 0;
          const prev = d?.previous ?? 0;
          const delta = d?.delta_pct;
          const up = cur >= prev;
          return (
            <div key={c.key} data-testid={`cmp-${c.key}`}
              className="rounded-lg border border-border bg-secondary/30 p-4">
              <p className="text-[10px] uppercase tracking-wider text-muted-foreground">{c.label}</p>
              <p className={`font-mono-num text-2xl font-bold mt-1 ${cur >= 0 ? "text-emerald-400" : "text-red-500"}`}>
                {fmt(cur)}
              </p>
              <div className="flex items-center gap-1 mt-1 text-[10px]">
                {delta === null || delta === undefined ? (
                  <span className="text-muted-foreground">no prior data</span>
                ) : (
                  <>
                    {up ? <TrendUp size={12} className="text-emerald-400" /> :
                          <TrendDown size={12} className="text-red-400" />}
                    <span className={up ? "text-emerald-400" : "text-red-400"}>
                      {delta > 0 ? "+" : ""}{delta}% vs prev
                    </span>
                  </>
                )}
              </div>
              <p className="text-[9px] text-muted-foreground mt-1">
                prev {fmt(prev)} · {d?.current_trades ?? 0} tr
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
